import { Injectable } from '@angular/core';

// Interfaces
import { InfinityTagsInterface, MutationMessage } from 'src/app/modules/dashboard/interfaces/infinity-tags.interface';
import { TagsInfinityWeb } from 'src/app/modules/dashboard/constants/tags-infinity';

@Injectable({
  providedIn: 'root'
})

export class InfinityService {

  // References
  public infinityTag: InfinityTagsInterface;
  public InfinityTags = TagsInfinityWeb;

  constructor() {
    // eslint-disable-next-line
    this.infinityTag = (window as any).ORA;
  }

  /**
   * Send Infinity general event
   * @param key The key of the custom tag
   * @param value The value of the custom tag
   */
  public sendCustomInfinityTag(key = '') {
    const tag = this.InfinityTags.filter(tag => tag.key.includes(key));

    const mutation = (msg: MutationMessage) => {
      msg.payload['InfinityTag'] = tag[0].value;
      msg.payload['source'] = 'AComerClubWeb';
      msg.payload['medium'] = 'Web';
      msg.payload['target'] = 'Page';
      msg.payload['type'] = 'Viewed';
      msg.payload['subtype'] = 'Page Viewed';
      msg.payload['device_id'] = localStorage.getItem('device_id') ?? '';
      msg.params.payload['wt.es'] = `${ window.location.origin }${ key }`;

      setTimeout(() => {
        msg.params.payload['dcsuri'] = window.location.pathname;
      }, 0);
    };

    setTimeout(() => {
      this.infinityTag.analytics.addMutation('myuniqueid', mutation);
      this.infinityTag.click();
    }, 500);
  }

}
